<template>
	<div class="input-upload" :class="{ 'input-upload_small': isSmall }">
		<label
			@drop.prevent="onDrop"
			@dragleave.prevent="onDragLeave"
			@dragover.prevent="onDragStart"
			:class="{
				disabled: isDisabled,
				error: isError,
			}"
		>
			<div
				class="input-upload__upload"
				:class="{
					disabled: isDisabled,
					error: isError,
					_drag: isDrag,
				}"
			>
				<div class="input-upload__title-container">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12ZM12 6.28571C12.5523 6.28571 13 6.73343 13 7.28571V11H16.7143C17.2666 11 17.7143 11.4477 17.7143 12C17.7143 12.5523 17.2666 13 16.7143 13H13V16.7143C13 17.2666 12.5523 17.7143 12 17.7143C11.4477 17.7143 11 17.2666 11 16.7143V13H7.28571C6.73343 13 6.28571 12.5523 6.28571 12C6.28571 11.4477 6.73343 11 7.28571 11H11V7.28571C11 6.73343 11.4477 6.28571 12 6.28571Z"
							fill="#252628"
						/>
					</svg>
					<p class="input-upload__title" v-html="getInputText.label"></p>
				</div>
				<p
					class="input-upload__description"
					v-html="getInputText.description"
				></p>
			</div>
			<input
				@change="onInputUpload"
				:name="fieldName"
				:accept="acceptFileExtensions"
				ref="file"
				type="file"
				:multiple="isMultiple"
			/>
		</label>

		<div class="input-upload__files" v-if="files.length > 0">
			<div
				class="input-upload__file"
				v-for="(file, index) in files"
				:key="`file-${index}`"
			>
				<div class="input-upload__file-icon">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V9H14C13.4477 9 13 8.55228 13 8V3H6ZM15 4.41421L17.5858 7H15V4.41421ZM7 9C7 8.44772 7.44772 8 8 8H10C10.5523 8 11 8.44772 11 9C11 9.55228 10.5523 10 10 10H8C7.44772 10 7 9.55228 7 9ZM7 13C7 12.4477 7.44772 12 8 12H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H8C7.44772 14 7 13.5523 7 13ZM7 17C7 16.4477 7.44772 16 8 16H16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H8C7.44772 18 7 17.5523 7 17Z"
							fill="#252628"
						/>
					</svg>
				</div>
				<div class="input-upload__file-info">
					<p class="input-upload__file-info-title" v-html="file.name"></p>
					<p class="input-upload__file-info-desc p2-medium">
						{{ getFileSize(file.size) }}
					</p>
				</div>
				<button
					class="input-upload__file-delete"
					type="button"
					@click.prevent="onDelete(index)"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3.20921 3.20921C3.48816 2.93026 3.94042 2.93026 4.21936 3.20921L8 6.98985L11.7806 3.20921C12.0596 2.93026 12.5118 2.93026 12.7908 3.20921C13.0697 3.48816 13.0697 3.94042 12.7908 4.21936L9.01015 8L12.7908 11.7806C13.0697 12.0596 13.0697 12.5118 12.7908 12.7908C12.5118 13.0697 12.0596 13.0697 11.7806 12.7908L8 9.01015L4.21936 12.7908C3.94042 13.0697 3.48816 13.0697 3.20921 12.7908C2.93026 12.5118 2.93026 12.0596 3.20921 11.7806L6.98985 8L3.20921 4.21936C2.93026 3.94042 2.93026 3.48816 3.20921 3.20921Z"
							fill="#252628"
						/>
					</svg>
				</button>
			</div>
		</div>
		<div class="input-upload__files" v-if="errFiles.length > 0">
			<div
				class="input-upload__file"
				v-for="(file, index) in errFiles"
				:key="`file-err-${index}`"
			>
				<div class="input-upload__file-icon input-upload__file-icon--err">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02943 21 2.99999 16.9706 2.99999 12C2.99999 7.02946 7.02943 3.00002 12 3.00002C16.9706 3.00002 21 7.02946 21 12Z"
							fill="#DE4A2A"
						/>
						<path
							d="M11 8V12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8Z"
							fill="#DE4A2A"
						/>
						<path
							d="M11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071C13.0976 15.3166 13.0976 14.6834 12.7071 14.2929C12.3166 13.9023 11.6834 13.9023 11.2929 14.2929C10.9024 14.6834 10.9024 15.3166 11.2929 15.7071Z"
							fill="#DE4A2A"
						/>
					</svg>
				</div>
				<div class="input-upload__file-info">
					<p class="input-upload__file-info-title" v-html="file.name"></p>
					<p class="input-upload__file-info-desc _err p2-medium">
						{{ file.err }}
					</p>
				</div>
				<button
					class="input-upload__file-delete"
					type="button"
					@click.prevent="onDelete"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M3.20921 3.20921C3.48816 2.93026 3.94042 2.93026 4.21936 3.20921L8 6.98985L11.7806 3.20921C12.0596 2.93026 12.5118 2.93026 12.7908 3.20921C13.0697 3.48816 13.0697 3.94042 12.7908 4.21936L9.01015 8L12.7908 11.7806C13.0697 12.0596 13.0697 12.5118 12.7908 12.7908C12.5118 13.0697 12.0596 13.0697 11.7806 12.7908L8 9.01015L4.21936 12.7908C3.94042 13.0697 3.48816 13.0697 3.20921 12.7908C2.93026 12.5118 2.93026 12.0596 3.20921 11.7806L6.98985 8L3.20921 4.21936C2.93026 3.94042 2.93026 3.48816 3.20921 3.20921Z"
							fill="#252628"
						/>
					</svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'inputUpload',
	props: {
		isDisabled: {
			type: Boolean,
			default: false,
		},
		isSmall: {
			type: Boolean,
			default: false,
		},
		isError: {
			type: Boolean,
			default: false,
		},
		maxFilesSize: {
			// Mb
			type: [String, Number],
			default: 30,
		},
		maxFilesLength: {
			type: [String, Number],
			default: 10,
		},
		maxOneFileSize: {
			// Mb
			type: [String, Number],
			default: 20,
		},
		acceptFileExtensions: {
			// через запятую, как в примере (можно без пробелов)
			type: String,
			default: '.jpg, .png, .pdf, .doc, .docx, .xls, .xlsx',
		},
		fieldName: {
			type: String,
			default: 'input-upload',
		},
	},
	data() {
		return {
			files: [],
			curFilesLength: 0,
			curFilesCommonSize: 0,
			acceptExtensions: '',
			errFiles: [],
			maxOneSize: 0, // Mb
			maxAllSize: 0, // Mb
			allowFilesLength: 0,
			allowExtArr: [],
			isDrag: false,
		}
	},
	computed: {
		getInputText() {
			let label = 'Перетащите или загрузите файлы'
			let description = `Файлы размером не&nbsp;более&nbsp;${this.maxOneFileSize}&nbsp;Мб каждый и&nbsp;не&nbsp;более&nbsp;${this.maxFilesSize}&nbsp;Мб суммарно`

			if (this.isSmall) {
				label = 'Загрузите файлы'
			}

			if (this.maxFilesLength == 1) {
				label = 'Перетащите или загрузите файл'
				description = `Файл размером не&nbsp;более&nbsp;${this.maxOneFileSize}&nbsp;Мб`

				if (this.isSmall) {
					label = 'Загрузите файл'
				}
			}

			if (this.maxFilesSize == this.maxOneFileSize) {
				description = `Файлы форматом: ${this.acceptFileExtensions}, размером не более ${this.maxFilesSize} мегабайт`
			}

			return {
				label: label,
				description: description,
			}
		},

		isMultiple() {
			if (this.maxFilesLength == 1) return false
			return true
		},
	},
	methods: {
		createFileList() {
			let dt = new DataTransfer()
			this.files.forEach(el => {
				const file = new File([el], el.name, { type: el.type })
				dt.items.add(file)
			})

			return dt.files
		},
		onInputUpload(e) {
			this.errFiles = []
			if (!e.target.files.length) return
			Object.values(e.target.files).forEach(file => {
				this.validateAndAddUploadedFile(file)
			})
			this.$refs.file.files = this.createFileList()
			this.$emit('onFilesUploaded', this.files)
		},
		onDrop(e) {
			this.errFiles = []
			if (!e.dataTransfer.files.length) return
			this.isDrag = false

			Object.values(e.dataTransfer.files).forEach(file => {
				this.validateAndAddUploadedFile(file)
			})

			this.$refs.file.files = e.dataTransfer.files
			this.$emit('onFilesUploaded', this.files)
		},
		onDragStart(e) {
			this.isDrag = true
			this.onDrop(e)
		},
		onDragLeave() {
			this.isDrag = false
		},
		onDelete(idx) {
			this.errFiles = []
			this.files = this.files.filter((file, index) => {
				if (index === idx) {
					const fileLength = this.getFileSizeInMb(file.size)
					this.curFilesCommonSize = this.curFilesCommonSize - fileLength
					this.curFilesLength = this.curFilesLength - 1
					return false
				}
				return true
			})

			this.$refs.file.files = this.createFileList()

			this.$emit('onFilesUploaded', this.files)
		},
		validateAndAddUploadedFile(file) {
			const fileSize = this.getFileSizeInMb(file.size)

			if (
				this.validateOneFileSize(fileSize, file.name) &&
				this.validateCommonFilesSize(fileSize, file.name) &&
				this.validateExt(file.name) &&
				this.validateFilesLength(file.name)
			) {
				this.curFilesCommonSize = this.curFilesCommonSize + fileSize
				this.curFilesLength = this.curFilesLength + 1
				this.files.push(file)
			}
		},
		getFileSizeInMb(size) {
			return Number((size / (1024 * 1024)).toFixed(2))
		},
		getFileSize(size) {
			// size - размер в байтах
			const sizeInKb = size / 1024
			if (!isNaN(sizeInKb) && sizeInKb < 1000) {
				return `${sizeInKb.toFixed(2)} Кб`
			}

			const sizeInMb = sizeInKb / 1024
			if (!isNaN(sizeInMb)) {
				return `${sizeInMb.toFixed(2)} Мб`
			}
		},
		validateOneFileSize(size, fileName) {
			if (size > this.maxOneSize) {
				this.errFiles.push({
					name: fileName,
					err: `Превышен допустимый размер файла в ${this.maxOneSize} Мб`,
				})
				return false
			}
			return true
		},
		validateCommonFilesSize(size, fileName) {
			if (size + this.curFilesCommonSize > this.maxAllSize) {
				this.errFiles.push({
					name: fileName,
					err: `Превышен общий допустимый размер файлов в ${this.maxOneSize} Мб`,
				})
				return false
			}
			return true
		},
		validateExt(fileName) {
			if (this.allowExtArr === 'all' || this.allowExtArr[0] === 'all')
				return true

			const fileExt = fileName.toLowerCase().match(/(\.[a-z]{1,4}$)/gm)
			if (!fileExt) {
				this.errFiles.push({
					name: fileName,
					err: `Файл не имеет расширения, допустимые расширения для загрузки: ${this.acceptFileExtensions}`,
				})
				return false
			}
			const findExt = this.allowExtArr.find(item => item === fileExt[0])
			if (!findExt) {
				this.errFiles.push({
					name: fileName,
					err: `Неверное расширение файла, допустимые расширения для загрузки: ${this.acceptFileExtensions}`,
				})
				return false
			}
			return true
		},
		validateFilesLength(fileName) {
			if (this.curFilesLength + 1 > this.allowFilesLength) {
				this.errFiles.push({
					name: fileName,
					err: `Не был загружен, допустимое количество файлов: ${this.maxFilesLength}`,
				})
				return false
			}
			return true
		},
		getFilesExtensions() {
			if (!this.acceptFileExtensions || this.acceptFileExtensions === 'all') {
				this.allowExtArr = 'all'
				return
			}

			const extStrWithoutSpaces = this.acceptFileExtensions.replace(/\s/gm, '')
			this.allowExtArr = extStrWithoutSpaces.split(',')
		},
		setUploadParams() {
			// устанавливаем параметры валидации из свойств компонента
			// вес всех файлов
			const maxFileSize = Number(this.maxFilesSize)
			if (isNaN(maxFileSize)) {
				console.error(
					'File Upload Err: свойство maxFileSize должно быть числом или числом в строке'
				)
			} else {
				this.maxAllSize = maxFileSize
			}

			// вес одного файла
			const maxOneFileSize = Number(this.maxOneFileSize)
			if (isNaN(maxOneFileSize)) {
				console.error(
					'File Upload Err: свойство maxOneFileSize должно быть числом или числом в строке'
				)
			} else {
				this.maxOneSize = maxOneFileSize
			}

			// количество файлов
			const allowFilesLength = Number(this.maxFilesLength)
			if (isNaN(allowFilesLength)) {
				console.error(
					'File Upload Err: свойство maxFilesLength должно быть числом или числом в строке'
				)
			} else {
				this.allowFilesLength = allowFilesLength
			}
		},
	},
	mounted() {
		this.getFilesExtensions()
		this.setUploadParams()
	},
}
</script>
